import { useIntl } from "react-intl";
import * as Yup from "yup";

export const ValidationSchema = () => {
  const { messages } = useIntl();
  const {
    package: {
      validation: {
        // imageRequired,
        nameRequired,
        priceRequired,
        numOfbooks,
        descriptionMaxLength
      }
    }
  } = messages;

  return Yup.object().shape({
    name: Yup.string().required(nameRequired),
    description: Yup.string().max(800, descriptionMaxLength),
    price: Yup.number().required(priceRequired),
    book_ids: Yup.array().test({
      message: numOfbooks,
      test: (arr) => arr.length > 1
    })
    // image_url: Yup.mixed().required(imageRequired)
  });
};

export const getInitialValuesAdd = () => ({
  name: "",
  price: "",
  image_url: null,
  book_ids: [],
  description: ""
});

export const getInitialValuesEditOrView = (packagevalue = {}) => {
  const book_ids = packagevalue?.items?.map((item) => item.id);
  return {
    name: packagevalue?.name || "",
    price: packagevalue?.price || "",
    image_url: packagevalue?.image_url || null,
    book_ids: book_ids || [],
    description: packagevalue?.description || ""
  };
};
